import React from 'react';
import styled from 'styled-components';
import { FlexColumn } from '@ubeya/shared-web/components';
import { media } from '@ubeya/shared-web/style';
import ClientLocations from './Locations';

const Details = styled(FlexColumn)`
  position: relative;
  overflow: scroll;
  flex: 2;
  height: 100%;
  ${media.tablet`overflow: auto;`}
`;

export const LocationsTab = ({ clientId, disableFieldsEdit }) => {
  if (!clientId) {
    return null;
  }
  return (
    <Details>
      <ClientLocations clientId={clientId} disableFieldsEdit={disableFieldsEdit} />
    </Details>
  );
};
